import React, { useContext, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import DisableAccess from '../DisableAccess';

import {
    Logo,
    Wrapper,
    InnerWrapper,
    ToolbarBackground,
    LoginButtonWrapper,
    ChildrenWrapper,
    MenuBackground,
    ToolbarWrapper,
    MenuWrapper,
    StartViewWrapper,
    EndViewWrapper,
    ProfileMenuWrapper
} from "./styled";
import { Space } from "components";
import DropdownMenu from "components/DropdownMenu";
import { withEmail } from "hocs/withEmail";
import { AppContext } from "hocs/withAppContext";

import { ReactComponent as UserIcon } from "assets/svgs/user.svg";

const profileMenuOptions = [
    { label: 'Logout', value: 'logout' }
];

const GoToApp = () =>
    <a target="_blank" href="https://app.onupkeep.com" className="disabled"
       rel="noopener noreferrer">Go To App</a>;

const ProfileMenu = withEmail(({ email, role }) => {
    if (!role) {
        return <GoToApp/>
    }

    if (!email) {
        return <Link to={`/${role.objectId}/login`}>
            <LoginButtonWrapper>
                Log In
            </LoginButtonWrapper>
        </Link>;
    }

    const [display, setDisplay] = useState(false);
    const handleOnChange = (option) => {
        setDisplay(!display);
        switch (option.value) {
            case 'logout':
                localStorage.removeItem('email');
                document.location.reload();
                break;
            default:
                return;
        }

    };
    return <>
        <DropdownMenu
            menuItems={profileMenuOptions}
            display={display}
            width="150"
            offsetX="45"
            offsetY="45"
            direction="bottom-right"
            onChange={handleOnChange}
        >
            <ProfileMenuWrapper onClick={() => setDisplay(!display)}>
                <UserIcon/>
                <span>{email}</span>
            </ProfileMenuWrapper>
        </DropdownMenu>

    </>;
});

const Layout = ({ children }) => {
    const { role } = useContext(AppContext);
    const isRequestPortalEnabled = role.isRequestPortalEnabled;
    const logo = role && role.companyLogo
        ? role.companyLogo.url
        : 'https://app.onupkeep.com/images/logo-red.svg';

    const VIEW = isRequestPortalEnabled === false ? <DisableAccess /> : <Wrapper>
    <ToolbarBackground/>
    {role && <MenuBackground/>}

    <InnerWrapper>
        <ToolbarWrapper>
            <StartViewWrapper>
                <Logo src={logo}/>
            </StartViewWrapper>
            <EndViewWrapper>
                <ProfileMenu role={role}/>
            </EndViewWrapper>
        </ToolbarWrapper>
        {role && <MenuWrapper>
            <StartViewWrapper>
                <NavLink to={`/${role.objectId}/work-orders`} activeClassName="active">
                    Work Order Requests
                </NavLink>
                <Space/>
                <NavLink to={`/${role.objectId}/purchase-orders`} activeClassName="active">
                    Purchase Order Requests
                </NavLink>
            </StartViewWrapper>
            <EndViewWrapper>
                <GoToApp/>
            </EndViewWrapper>
        </MenuWrapper>}
        <ChildrenWrapper>
            {children}
        </ChildrenWrapper>
    </InnerWrapper>
    </Wrapper> ;
    return VIEW;
};

export default Layout;
